import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { debounce, debounceTime, Subscription } from 'rxjs';
import { ConfigurationService } from 'src/app/services/configuration/configuration.service';
import { onlyNumbers } from 'src/helpers/string-helpers';

@Component({
  selector: 'input-stock-quantity',
  templateUrl: './input-stock-quantity.component.html',
  styleUrls: ['./input-stock-quantity.component.scss']
})
export class InputStockQuantity implements OnInit, OnDestroy {

  @Input() controlName!: string;
  @Input() label!: string;
  @Input() unitDescription: string = "";
  @Input() fractional!: boolean;
  form!: FormGroup;
  formControl_Quantity!: AbstractControl;
  private valueStock$?: Subscription;

  constructor(private rootFormGroup: FormGroupDirective,
    private configuration: ConfigurationService) { }

  ngOnDestroy(): void {
    this.valueStock$?.unsubscribe();
  }

  ngOnInit(): void {
    this.form = this.rootFormGroup.control;
    this.formControl_Quantity = this.form.controls[this.controlName];
    this.setValidators();
    this.validateStockQuantity();
  }

  formatStockFractional() {
    let quantity = this.formControl_Quantity.value?.toString();
    if (this.fractional) {
      if (!quantity) return;
      quantity = quantity.replace(/\./g, '').replace(/[a-z]/gi, '').trim();
      let parts = quantity.split(','); // Verifica se o número contém uma vírgula e divide em partes antes e depois da vírgula
      if (parts.length === 1) {
        parts = quantity.split('.'); // Verifica se o número contém um ponto decimal e divide em partes antes e depois do ponto
      }
      let integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');  // Formata a parte inteira
      let decimalPart = "";

      if (integerPart)
        decimalPart = parts.length > 1 ? ',' + parts[1].padEnd(3, '0') : ',000'; // Verifica se há uma parte decimal e a formata

      quantity = integerPart + decimalPart.substring(0, 4);   // Retorna o número formatado
      this.formControl_Quantity.setValue(quantity);
    }
  }

  private setValidators() {
    this.formControl_Quantity.clearValidators();
    this.formControl_Quantity.setValidators([Validators.required]);
    if (!this.fractional) {
      this.formControl_Quantity.setValidators([
        Validators.pattern("^[0-9]*$"),
        Validators.min(0),
        Validators.max(999999999),
      ]);
    }
  }

  private validateStockQuantity() {
    this.valueStock$ = this.formControl_Quantity.valueChanges.pipe(debounceTime(300)).subscribe((stock: string) => {
      if (stock && stock.startsWith('-')) {
        this.formControl_Quantity.setErrors({ 'negative': true })
        return;
      }
      if (this.fractional) {
        const stockDecimal = parseFloat(stock.replace('.', '').replace(',', '.').replace(/\.(?=.*\.)/g, ''))
        if (stockDecimal > 999999999){
          this.formControl_Quantity.setErrors({ 'maxReached': true })
          return;
        }
      }

      if (this.fractional == false && +onlyNumbers(stock) > 999999999) {
        this.formControl_Quantity.setErrors({ 'maxReached': true })
        return;
      }
    })
  }
}
